var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not_app"},[_c('a-result',{attrs:{"status":"warning","title":`应用无法访问，请联系管理员。`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }